// Common function to show or hide search elements
function toggleSearchElements(elements, show) {
    if (show) {
        elements.collectionSelect.style.display = "block";
        elements.searchButton.style.display = "inline-block";
        elements.resetButtonSearchSvg.style.display = "none";  // Hide search icon
        elements.resetButtonIconCloseSvg.style.display = "block";  // Show close icon
    } else {
        elements.collectionSelect.style.display = "none";
        elements.searchButton.style.display = "none";
        elements.resetButtonSearchSvg.style.display = "block";  // Show search icon
        elements.resetButtonIconCloseSvg.style.display = "none";  // Hide close icon
    }
}

// Function to initialize and set up event listeners
function initializeSearchElements(baseSelector) {
    var searchInput = document.querySelector(`${baseSelector} .search__input`);
    var collectionSelect = document.querySelector(`${baseSelector} .collection-select`);
    var searchButton = document.querySelector(`${baseSelector} .search__button`);
    var resetButton = document.querySelector(`${baseSelector} .reset__button`);
    var resetButtonIconCloseSvg = document.querySelector(`${baseSelector} .reset__button .icon-close`);
    var resetButtonSearchSvg = document.querySelector(`${baseSelector} .reset__button .searchicon-svg`);

    // Ensure the elements exist before proceeding
    if (searchInput && collectionSelect && searchButton && resetButton && resetButtonSearchSvg && resetButtonIconCloseSvg) {

        // Initially hide the select and search button
        toggleSearchElements({ collectionSelect, searchButton, resetButtonSearchSvg, resetButtonIconCloseSvg }, false);

        // Show elements when the input is focused
        searchInput.addEventListener("focus", function () {
            toggleSearchElements({ collectionSelect, searchButton, resetButtonSearchSvg, resetButtonIconCloseSvg }, true);
        });

        // Hide elements when the reset button is clicked
        resetButton.addEventListener("click", function (event) {
            event.preventDefault();
            searchInput.value = "";
            toggleSearchElements({ collectionSelect, searchButton, resetButtonSearchSvg, resetButtonIconCloseSvg }, false);
        });

        // Toggle elements when the search icon (resetButtonSearchSvg) is clicked
        resetButtonSearchSvg.addEventListener("click", function () {
            var elementsVisible = collectionSelect.style.display === "block";
            toggleSearchElements({ collectionSelect, searchButton, resetButtonSearchSvg, resetButtonIconCloseSvg }, !elementsVisible);
        });
    }
}

// Initialize search elements for each selector
initializeSearchElements(".menu-bar .mobile-search__form");
initializeSearchElements(".header-mid-bar .mobile-search__form");
